import { Snippet } from '../../dataModels';

export const taskSnippet: Snippet = {
  shiftsummaryDisplyId: '11601885-bbf3-ec11-9147-005056b29cce',
  displayTemplateId: 'f6aade8a-fdec-41ce-90be-bba0953f289f',
  name: 'Task',
  displayName: 'Task',
  description: 'Task',
  order: 8,
  type: 'Task',
  enableEdit: 'False',
  enableComment: false,
  isEdited: false,
  configuration: {
    rowTitleKey: 'name',
    columnCount: 13,
    columns: [
      {
        id: 1,
        name: 'taskId',
        displayName: 'taskId',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'False',
      },
      {
        id: 2,
        name: 'name',
        displayName: 'Task Name',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 3,
        name: 'assetDisplayName',
        displayName: 'Asset Name',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 4,
        name: 'typeDisplayName',
        displayName: 'Task Type',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 5,
        name: 'priority',
        displayName: 'Priority',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 6,
        name: 'startTime',
        displayName: 'Planned Start Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 7,
        name: 'endTime',
        displayName: 'Planned End Time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 8,
        name: 'assignees',
        displayName: 'Assignees',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 9,
        name: 'state',
        displayName: 'Status',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 10,
        name: 'actualStartTime',
        displayName: 'Actual start time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 11,
        name: 'actualEndTime',
        displayName: 'Actual end time',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 12,
        name: 'completionPercent',
        displayName: '% Complete',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 13,
        name: 'description',
        displayName: 'Description',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: 'True',
      },
    ],
    matrixCells: null,
  },
  data: [
    {
      rollupDetails: null,
      rowCount: 6,
      rowData: [
        {
          taskId: 'f2cb538a-0df3-ec11-9147-005056b29cce',
          name: 'Daily- Reminder to review procedure (N) - Field1',
          assetDisplayName: 'Field1',
          typeDisplayName: 'AD-Administration',
          priority: 'High',
          startTime: '2022-06-24 13:20:00',
          endTime: '2022-06-25 13:20:00',
          assignees: 'System Administrator;XOM System Administrator',
          state: 'Planned',
          actualStartTime: '',
          actualEndTime: '',
          completionPercent: '0',
          description: 'Reminder to review procedure per oims 6.1 requirement if time allows.',
        },
        {
          taskId: 'f1cb538a-0df3-ec11-9147-005056b29cce',
          name: 'Daily- Daily Process Activities (N) - Field1',
          assetDisplayName: 'Field1',
          typeDisplayName: 'AD-Administration',
          priority: 'High',
          startTime: '2022-06-24 12:45:00',
          endTime: '2022-06-26 12:45:00',
          assignees: 'System Administrator;XOM System Administrator',
          state: 'Planned',
          actualStartTime: '',
          actualEndTime: '',
          completionPercent: '0',
          description:
            'Daily- Process Activities : read night orders & logbook, rounds, log book, shift relief, work permits, routine work',
        },
        {
          taskId: 'f4cb538a-0df3-ec11-9147-005056b29cce',
          name: 'Test DOL Mobile App',
          assetDisplayName: 'BusTeam1',
          typeDisplayName: 'HSE',
          priority: 'High',
          startTime: '2022-06-24 03:00:00',
          endTime: '2022-06-25 03:00:00',
          assignees: 'Engineer;Operator;System Administrator;XOM System Administrator',
          state: 'Planned',
          actualStartTime: '',
          actualEndTime: '',
          completionPercent: '0',
          description: 'Test DOL Mobile App',
        },
        {
          taskId: 'aaa6d45f-44f2-ec11-9147-005056b29cce',
          name: 'Daily- Reminder to review procedure (N) - Field1',
          assetDisplayName: 'Field1',
          typeDisplayName: 'AD-Administration',
          priority: 'High',
          startTime: '2022-06-23 13:20:00',
          endTime: '2022-06-24 13:20:00',
          assignees: 'System Administrator;XOM System Administrator',
          state: 'Cancelled',
          actualStartTime: '2022-06-23 14:28:00',
          actualEndTime: '',
          completionPercent: '10',
          description: 'Reminder to review procedure per oims 6.1 requirement if time allows.',
        },
        {
          taskId: 'a9a6d45f-44f2-ec11-9147-005056b29cce',
          name: 'Daily- Daily Process Activities (N) - Field1',
          assetDisplayName: 'Field1',
          typeDisplayName: 'AD-Administration',
          priority: 'High',
          startTime: '2022-06-23 12:45:00',
          endTime: '2022-06-25 12:45:00',
          assignees: 'System Administrator;XOM System Administrator',
          state: 'Paused',
          actualStartTime: '2022-06-23 14:40:00',
          actualEndTime: '',
          completionPercent: '0',
          description:
            'Daily- Process Activities : read night orders & logbook, rounds, log book, shift relief, work permits, routine work',
        },
        {
          taskId: '572f2837-7bf1-ec11-9147-005056b29cce',
          name: 'Daily- Daily Process Activities (N) - Field1',
          assetDisplayName: 'Field1',
          typeDisplayName: 'AD-Administration',
          priority: 'High',
          startTime: '2022-06-22 12:45:00',
          endTime: '2022-06-24 12:45:00',
          assignees: 'System Administrator;XOM System Administrator',
          state: 'In-Progress',
          actualStartTime: '2022-06-23 19:42:00',
          actualEndTime: '',
          completionPercent: '0',
          description:
            'Daily- Process Activities : read night orders & logbook, rounds, log book, shift relief, work permits, routine work',
        },
      ],
    },
  ],
  count: 0,
  groupSnippets: null,
  maxRows: 0,
  canAddDeleteRows: false,
};
